export default __webpack_public_path__ + "static/media/Real_estate.fc6138e3.JPG";